import React, { useEffect, useRef, useState } from "react";

function FullAgreementPage() {
  const [pdfSrc, setPdfSrc] = useState(null);
  const pdfPath = "/Rule_of_drone_deployment.pdf";

  return (
    <div
      style={{
        position:"fixed",
        top:"0",
        left:"0",
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      
        <iframe
          src={pdfPath}
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        ></iframe>

    </div>
  );
}

export default FullAgreementPage;
